import { render, staticRenderFns } from "./_cv-breadcrumb-item-skeleton.vue?vue&type=template&id=f06bb100&"
import script from "./_cv-breadcrumb-item-skeleton.vue?vue&type=script&lang=js&"
export * from "./_cv-breadcrumb-item-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports